import { useState } from "react";
import styles from "./AlertPage.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { ArrowBack } from "react-ionicons";

const AlertPage
  = ({ title, description }) => {
    return (
      <section className={`global-section ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          <div className={styles.AlertPage}>
            <h1 className={styles.Title}>{title}</h1>
            <p className={styles.Description}>{description}</p>

            <div className={styles.ButtonContainer}>
              <Link to="/">
                <Button>
                  Retour à l’accueil
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

    );
  }

export default AlertPage;
